import { render, staticRenderFns } from "./TicketCounters.html?vue&type=template&id=467dea0c&scoped=true&external"
import script from "./TicketCounters.vue?vue&type=script&lang=js"
export * from "./TicketCounters.vue?vue&type=script&lang=js"
import style0 from "./TicketCounters.scss?vue&type=style&index=0&id=467dea0c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467dea0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VIcon,VSkeletonLoader})
